export default {
  env: 'preproduction',
  assetsEndpoint: 'https://static.pre.mdirector.com/assets/',
  storage: {
    domain: 'https://app.pre.mdirector.com',
    file: '/storage.php',
  },
  services: {
    email_marketing: { frontUrl: 'https://app.pre.mdirector.com' },
    email_transactional: { frontUrl: 'https://trans.pre.mdirector.com' },
    marketing_automation: { frontUrl: 'https://automation.pre.mdirector.com' },
    landing_optimizer: { frontUrl: 'https://landings.pre.mdirector.com' },
    payments: { frontUrl: 'https://payments.pre.mdirector.com' },
    integrations: {
      frontUrl: 'https://signup.pre.mdirector.com',
      zapier: true,
      shopify: true,
      apis: true,
    },
  },
};
